var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 51,
    viewBox: "0 0 53 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51.36,
    height: 50,
    rx: 25,
    fill: "#F5F5F5",
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.222 30.352C17.4535 31.405 12.8167 33.5551 15.6408 36.2457C17.0204 37.56 18.5569 38.5 20.4886 38.5H31.5114C33.4431 38.5 34.9796 37.56 36.3592 36.2457C39.1833 33.5551 34.5465 31.405 32.778 30.352C28.631 27.8827 23.369 27.8827 19.222 30.352Z",
    stroke: "#7A808A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 19.125C31.625 22.2316 29.1066 24.75 26 24.75C22.8934 24.75 20.375 22.2316 20.375 19.125C20.375 16.0184 22.8934 13.5 26 13.5C29.1066 13.5 31.625 16.0184 31.625 19.125Z",
    stroke: "#7A808A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.517df0d7ec709691ff9a02e51919b51e.svg";
export { ForwardRef as ReactComponent };